import { getDeviceCapabilities, updateDeviceCapabilities, getWebDeviceCapabilities, codecToAudioFormat, AudioFormat, } from '@zattoo/playback-sdk';
import { StreamProvider } from '../stream/vod/stream-provider';
import { maxQuality as rakutenMaxQuality } from './rakuten';
export const maxQualityPlayable = (deviceCapabilities, streamProvider) => {
    if (streamProvider === StreamProvider.RAKUTEN) {
        return rakutenMaxQuality(deviceCapabilities);
    }
    return null;
};
export const getPlaybackCapability = async (streamProvider) => {
    const capabilities = await getDeviceCapabilities();
    const dolbyCodec = capabilities.audioCodecs?.some((codec) => (codecToAudioFormat(codec) === AudioFormat.DOLBY)) ?? false;
    return {
        ...capabilities,
        maxQualityPlayable: maxQualityPlayable(capabilities, streamProvider),
        dolbySupported: dolbyCodec,
    };
};
export { updateDeviceCapabilities, getWebDeviceCapabilities, };
